// extracted by mini-css-extract-plugin
module.exports = {"preloaderWrap":"styles_preloaderWrap___taIL"};